import {Page} from "../../Common/Component/Page/Page";
import {Card, Col, Row} from "react-bootstrap";
import {useEffect, useState} from "react";
import {Loading} from "../../Common/Component/Loading/Loading";
import {useParams} from "react-router-dom";
import {ReactTableV2} from "../ListPage/Components/Table/ReactTableV2";
import {ListPageHeader} from "../ListPage/Components/ListPageHeader";
import ListSchemaConfig from "../../Common/Schema/ListSchemaConfig";

export const ListPageV2 = () => {

    const [pageSchema, setPageSchema] = useState(null);
    const {entity} = useParams();
    const [isLoading, setLoading] = useState(true);

    const [isError, setError] = useState(false);

    const loadSchema = async () => {
        try {
            const listSchemaConfig = new ListSchemaConfig();
            const x = await listSchemaConfig.getListSchemaByName(entity);
            setPageSchema({tableSchema: x})
            setError(false);
            setLoading(false);
        } catch (e) {
            console.log('Error', e);
            setError(true);
            setLoading(false);
        }
    };

    useEffect(() => {
        if (!entity) {
            return;
        }
        setLoading(true);
        console.log('Buscando entidade...', entity)
        loadSchema();
    }, [entity]);


    if (isError) {
        return <Page>
            <Card>
                <Card.Body>
                    <Row>
                        <Col>
                            <p>Algo deu errado, tenta novamente mais tarde!</p>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
        </Page>
    }

    if (!pageSchema || isLoading) {
        return <Loading/>
    }

    return (
        <Page>
            <Card>
                <Card.Body>
                    <ListPageHeader headerConfig={pageSchema.tableSchema.header}/>
                    <Row>
                        <Col>
                            <ReactTableV2 tableSchema={pageSchema.tableSchema}/>
                        </Col>
                    </Row>

                </Card.Body>
            </Card>
        </Page>
    )
}
